import commonMessages from '@rhg/lang/messages/common';
import { LinearProgress } from '@rhg/libs/material';
import { useIntl } from 'react-intl';

const styleLoader = {
    width: '100dvw',
};

export function FullWidthLinearProgress() {
    const { formatMessage } = useIntl();
    return (
        <LinearProgress
            style={styleLoader}
            aria-label={formatMessage(commonMessages['common.loading'])}
            color="secondary"
        />
    );
}
